import { countryCodes, getCountryName } from './countryUtils';

const displayNamesCache: Record<string, Intl.DisplayNames> = {};

const getDisplayNames = (locale: string): Intl.DisplayNames => {
  if (!displayNamesCache[locale]) {
    displayNamesCache[locale] = new Intl.DisplayNames([locale], {
      type: 'region',
    });
  }
  return displayNamesCache[locale];
};

const getLocalizedName = (code: string, locale: string): string => {
  try {
    return getDisplayNames(locale).of(code) ?? code;
  } catch {
    return getCountryName(code) || code;
  }
};

interface CountryEntry {
  code: string;
  name: string;
}

const getSortedEntries = (locale: string): CountryEntry[] => {
  const entries: CountryEntry[] = countryCodes.map((code: string) => ({
    code,
    name: getLocalizedName(code, locale),
  }));
  entries.sort((a, b) => a.name.localeCompare(b.name, locale));
  return entries;
};

export const getLocalizedCountryMap = (
  locale: string
): Record<string, string> => {
  const map: Record<string, string> = {};
  for (const { code, name } of getSortedEntries(locale)) {
    map[code] = name;
  }
  return map;
};

export const getLocalizedCountryList = (
  locale: string
): Array<{ value: string; text: string }> => {
  return getSortedEntries(locale).map(({ code, name }) => ({
    value: code,
    text: name,
  }));
};
